export function addTotalsColumnToHeader(data, header) {
  let currentBuilding = '';
  const buildings = {};

  data.forEach((item) => {
    if (item.parent) {
      currentBuilding = item.name;
      buildings[currentBuilding] = {};
      header.forEach((headerItem) => {
        buildings[currentBuilding][headerItem.key] = 0;
      });
    } else {
      header.forEach((headerItem) => {
        if (currentBuilding) {
          buildings[currentBuilding][headerItem.key] += item[headerItem.key] || 0;
        }
      });
    }
  });

  data = data.map((item) => {
    if (item.parent) {
      item.total = buildings[item.name];
    }
    return item;
  });

  return data;
}
